// Rebuy Smart Cart / mini cart translation logic. The translated strings are rendered by
// snippets/rebuy-translation.liquid into window.rebuyTranslations; see that snippet for context.
//
// This lives in a plain .js asset (not inline in the snippet) because Shopify parses .liquid files
// as Liquid: a literal "{{...}}" in JS there is read as a Liquid output tag and Shopify rewrites it

(function () {
  const translations = window.rebuyTranslations;
  if (!translations) return;
  
  function decodeHtmlEntities(value) {
    if (typeof value !== 'string' || value.indexOf('&') === -1) return value;
    const el = document.createElement('textarea');
    el.innerHTML = value;
    return el.value;
  }

  function restoreRebuyTokens(value) {
    value = decodeHtmlEntities(value);
    return typeof value === 'string' ? value.replace(/\[\[([a-zA-Z0-9_]+)\]\]/g, '{{$1}}') : value;
  }

  function normalizeTokens(node) {
    Object.keys(node).forEach(function (key) {
      const value = node[key];
      if (value && typeof value === 'object') {
        normalizeTokens(value);
      } else {
        node[key] = restoreRebuyTokens(value);
      }
    });
  }
  normalizeTokens(translations);

  // Only copies non-empty strings, so untranslated/optional keys fall back to Rebuy's own defaults
  // instead of blanking out UI copy that hasn't been given real content yet.
  function assignTranslated(target, source) {
    if (!target || !source) return;
    Object.keys(source).forEach(function (key) {
      const value = source[key];
      if (value === '') return;
      target[key] = value;
    });
  }

  window.updateSmartCartLanguage = function () {
    const translation = translations.smart_cart;
    const subscriptionTranslations = translations.cart_switch_to_subscription;
    const tierProgressBarTranslations = translations.tier_progress_bar;
    const components = Rebuy.SmartCart.settings.components;
    const buyMoreSaveMore = Rebuy.SmartCart.settings.buy_more_save_more;
    const emptyCart = Rebuy.SmartCart.settings.empty_cart_markup;
    const switchToSubscription = Rebuy.SmartCart.settings.switch_to_subscription;
    const storefrontHelper = new ShopifyStorefrontHelper();

    if (!components) return;

    components.forEach(function (component) {
      switch (component.type) {
        case 'checkout':
          assignTranslated(component.settings.language, {
            checkout_label: translation.checkout_label,
            view_cart_label: translation.view_cart_label,
            checking_out_label: translation.checking_out_label,
            view_cart_working_label: translation.view_cart_working_label,
            continue_shopping_label: translation.continue_shopping_label,
            terms_and_conditions_label: translation.terms_and_conditions_label
          });
          break;
        case 'cart_subtotal':
          assignTranslated(component.settings, {
            subtotal_plural_text: translation.subtotal_plural_text,
            subtotal_singular_text: translation.subtotal_singular_text
          });
          break;
        case 'tiered_progress_bar': {
          const progressBarTranslation = {
            free_shipping_reached: tierProgressBarTranslations.free_shipping_reached,
            free_shipping_remaining: tierProgressBarTranslations.free_shipping_remaining,
            product_amount_reached_label_text: tierProgressBarTranslations.product_amount_reached_label_text,
            product_amount_remaining_label_text: tierProgressBarTranslations.product_amount_remaining_label_text,
            decorative_amount_reached_label_text: tierProgressBarTranslations.decorative_amount_reached_label_text,
            decorative_amount_remaining_label_text: tierProgressBarTranslations.decorative_amount_remaining_label_text,
            discount_amount_remaining_label_text: tierProgressBarTranslations.discount_amount_remaining_label_text,
            discount_amount_reached_label_text: tierProgressBarTranslations.discount_amount_reached_label_text
          };
          if (component.settings.bars) {
            component.settings.bars.forEach(function (bar) {
              assignTranslated(bar.language, progressBarTranslation);
              (bar.earnedProducts || []).forEach(function (product) { storefrontHelper.updateProductJSON(product); });
              (bar.tiers || []).forEach(function (tier, index) {
                if (tier.type !== 'shipping') {
                  assignTranslated(tier, progressBarTranslation);
                  if (tier.type === 'product') {
                    storefrontHelper.updateProductJSON(tier.products[0]);
                  }
                }
                if (tier.type === 'shipping' && tierProgressBarTranslations.free_shipping) {
                  const stepLabels = document.querySelectorAll('.rebuy-cart__progress-step-label');
                  if (stepLabels[index]) {
                    stepLabels[index].innerText = tierProgressBarTranslations.free_shipping;
                  }
                }
              });
            });
          }
          break;
        }
        case 'title_bar':
          assignTranslated(component.settings, { title: translation.cart_title });
          break;
        case 'login':
          assignTranslated(component.settings.language, { title: translation.login_title });
          break;
        case 'discount_code':
          assignTranslated(component.settings.language, {
            discount_code_label: translation.discount_code_label,
            discount_button_label: translation.discount_button_label,
            discount_invalid_message: translation.discount_invalid_message
          });
          break;
        case 'notes':
          assignTranslated(component.settings.language, {
            notes_label: translation.notes_label,
            notes_placeholder: translation.notes_placeholder,
            notes_remaining_characters: translation.notes_remaining_characters
          });
          break;
      }
    });

    if (buyMoreSaveMore) {
      assignTranslated(buyMoreSaveMore.language, {
        bmsm_discount_message: translation.bmsm_discount_message,
        bmsm_discount_success: translation.bmsm_discount_success
      });
    }

    if (emptyCart) {
      assignTranslated(Rebuy.SmartCart.settings, { empty_cart_markup: translation.empty_cart_markup });
    }

    if (switchToSubscription) {
      assignTranslated(switchToSubscription.language, subscriptionTranslations);
    }
  };

  // Cart Recs is a single, fixed SmartCart widget - its ID never changes.
  const CART_RECS_WIDGET_ID = '238318';

  window.updateWidgetLanguage = function (widget) {
    const language = widget.data.settings.language;
    const originalTitle = ((language && language.title) || '').trim().toLowerCase();
    const widgetId = widget.id || widget._id || widget.widget_id;

    assignTranslated(language, translations.widget);

    if (widgetId === CART_RECS_WIDGET_ID) {
      assignTranslated(language, { title: translations.widget.recs_title });
    } else if (originalTitle === 'special offer') {
      // Rebuy spawns a separate "Special Offer" bump widget per eligible product, each with
      // its own ID, so these are matched by their (untranslated) default title instead of ID.
      assignTranslated(language, {
        title: translations.widget.special_offer_title,
        description: translations.widget.special_offer_description
      });
    }

    widget.compileConfig();
  };

  window.updateTierLanguage = function () {
    const giftTitle = document.querySelector('.rebuy-cart__progress-gifts-title');
    const variantPrompts = document.querySelectorAll('.rebuy-cart__progress-gift-variant-select-prompt');
    const firstOptions = document.querySelectorAll('.rebuy-cart__progress-gift-variant-select option[value=""]');
    const readdButtons = document.querySelectorAll('.rebuy-cart__progress-gift-variant-readd');

    if (giftTitle && translations.smart_cart.gift_title) {
      giftTitle.textContent = translations.smart_cart.gift_title;
    }
    if (translations.smart_cart.select_gift) {
      variantPrompts.forEach(function (prompt) { prompt.textContent = translations.smart_cart.select_gift; });
      firstOptions.forEach(function (option) { option.textContent = translations.smart_cart.select_gift; });
    }
    if (translations.smart_cart.readd_gift) {
      readdButtons.forEach(function (button) { button.textContent = translations.smart_cart.readd_gift; });
    }
  };

  // These three strings are hardcoded into custom Rebuy component templates (edited directly in
  // Rebuy's Template Editor), not exposed via any settings/language field - so they can only be
  // fixed by overwriting the rendered DOM text, same approach as updateTierLanguage above.
  window.updateHardcodedTemplateStrings = function () {
    const discountToggleLabel = document.querySelector('.rebuy-cart__discount-form-button span');
    if (discountToggleLabel && translations.smart_cart.apply_discount_code_toggle_label) {
      discountToggleLabel.textContent = translations.smart_cart.apply_discount_code_toggle_label;
    }

    const removeLabels = document.querySelectorAll('.rebuy-cart__flyout-item-remove span');
    if (translations.smart_cart.remove_item_label) {
      removeLabels.forEach(function (label) { label.textContent = translations.smart_cart.remove_item_label; });
    }

    const giftBagToggleLabel = document.querySelector('.rebuy-cart__notes-toggle-label');
    if (giftBagToggleLabel && translations.smart_cart.gift_bag_toggle_label) {
      const textNode = Array.prototype.find.call(giftBagToggleLabel.childNodes, function (node) {
        return node.nodeType === Node.TEXT_NODE && node.nodeValue.trim();
      });
      if (textNode) textNode.nodeValue = ' ' + translations.smart_cart.gift_bag_toggle_label + ' ';
    }

    // Matched by exact default text, not just the class, since this slot may carry other
    // discount messages too - only overwrite the ones that are still the untranslated default.
    const discountLines = document.querySelectorAll('.rebuy-cart__flyout-item-discount-line');
    if (translations.smart_cart.free_gift_label) {
      discountLines.forEach(function (line) {
        if (line.textContent.trim() === 'Free Gift') {
          line.textContent = translations.smart_cart.free_gift_label;
        }
      });
    }

    // Populated by Rebuy's own hosted script against an empty <span> in its title_bar template -
    // no settings/language field exists for it, so it's driven directly off the live cart count.
    const cartCountEl = document.querySelector('.title-cart-count-text');
    const itemCount = window.Rebuy && Rebuy.Cart && Rebuy.Cart.cart && Rebuy.Cart.cart.item_count;
    if (cartCountEl && typeof itemCount === 'number') {
      const countTemplate = itemCount === 1
        ? translations.smart_cart.item_count_singular_text
        : translations.smart_cart.item_count_plural_text;
      if (countTemplate) {
        cartCountEl.textContent = countTemplate.replace('{{item_count}}', itemCount);
      }
    }
  };

  window.updateAnnouncementBar = function () {
    const configuredBars = translations.announcement_bar && translations.announcement_bar.bars;
    const components = Rebuy.SmartCart.settings.components;
    if (!configuredBars || !components) return;

    const announcementBars = components.filter(function (c) { return c.type === 'announcement_bar'; });
    announcementBars.forEach(function (component, index) {
      const configuredBar = configuredBars[index];
      if (!configuredBar) return;
      const messages = configuredBar.messages.filter(function (message) { return message; });
      if (messages.length) {
        component.settings.messages = messages;
      }
    });
  };

  document.addEventListener('rebuy:smartcart.ready', function () {
    updateTierLanguage();
    updateSmartCartLanguage();
    updateAnnouncementBar();
    updateHardcodedTemplateStrings();

    // The gift-variant area (e.g. the Re-Add button) can be inserted by Rebuy asynchronously,
    // after this ready event and independently of any rebuy:cart.change event - so a one-off
    // call above can run before it exists. Re-translate whenever Rebuy mutates that region.
    const goalBox = document.querySelector('[data-rebuy-cart-anchor="goalBox"]');
    if (goalBox && !goalBox._rebuyTierObserverAttached) {
      goalBox._rebuyTierObserverAttached = true;
      const observerConfig = { childList: true, subtree: true };
      const goalBoxObserver = new MutationObserver(function () {
        // updateTierLanguage() writes into this same subtree, so disconnect while it runs -
        // otherwise our own text updates re-trigger this callback in an infinite loop.
        goalBoxObserver.disconnect();
        updateTierLanguage();
        goalBoxObserver.observe(goalBox, observerConfig);
      });
      goalBoxObserver.observe(goalBox, observerConfig);
    }
  });

  document.addEventListener('rebuy.ready', function (event) {
    updateWidgetLanguage(event.detail.widget);
  });

  document.addEventListener('rebuy:cart.change', function () {
    setTimeout(function () {
      updateTierLanguage();
      updateSmartCartLanguage();
      updateAnnouncementBar();
      updateHardcodedTemplateStrings();
    }, 0);
  });

  document.addEventListener('rebuy.productsChange', function (event) {
    const widget = event.detail.widget;
    const storefrontHelper = new ShopifyStorefrontHelper();
    widget.data.products.forEach(function (product) { storefrontHelper.updateProductJSON(product); });
  });
})();
